<div class="container text-center">
    <div class="row">
        <div class="col-12">
            <h1>Error 404: Page Not Found</h1>
            <h3>This page has moved or no longer exists. Please use the navigation bar above to find the page you want.</h3>
        </div>
    </div>
</div>